export const legalCookies = [
  {
    key: 'cookies_accept_needed',
    name: 'Cookies Necesarias',
    description:
      'Las cookies necesarias son aquellas que duran el tiempo que el usuario está navegando por la página Web y se borran al término.',
    value: true,
    required: true,
  },
  {
    key: 'cookies_accept_analytics',
    name: 'Cookies de Estadísticas',
    description:
      'Las cookies de estadísticas son aquellas que utilizamos para generar informes de uso de la página Web, los cuales nos ayudan a mejorar su funcionamiento.',
    value: true,
    required: false,
  },
  {
    key: 'cookies_accept_preferences',
    name: 'Cookies de Preferencias',
    description:
      'Las cookies de preferencias son aquellas que utilizamos para almacenar las opciones que marques en este menú de configuración.',
    value: true,
    required: true,
  },
  {
    key: 'cookies_accept_marketing',
    name: 'Cookies de Marketing',
    description: 'Las cookies de marketing son aquellas que utilizamos para identificarte en campañas',
    value: true,
    required: false,
  },
];

export const legalCookiesConfiguredKey = 'cookies_configured';

export const legalCookiesRejectedKey = 'cookies_reject_all';
